'use client';

import type { PersonAllocation } from '@/app/models/providersResponse';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Column } from '../common/DataTable';
import ExpandableDataTable from '../common/ExpandableDataTable';
import EventsCollaboratorTable from './eventsCollaboratorTable';

type EventTableParams = {
  rows: PersonAllocation[];
};

export default function CollaboratorTable(props: EventTableParams) {
  const { rows } = props;
  const { t } = useTranslation(['provider', 'common']);

  const columns: Column[] = [
    { key: 'collaborator', label: t('collaborator'), width: '740px' },
    { key: 'salary', label: `${t('salary')}`, width: '140px' },
    { key: 'percentage', label: `${t('percentage')}`, width: '100px', align: 'center' },
    { key: '', label: '' },
  ];

  // For expandable rows, we need a special renderRow function that returns the EventsCollaboratorTable component
  const renderRow = (row: PersonAllocation) => <EventsCollaboratorTable row={row} />;

  // Use person ID as the unique key, fallback to index if not available
  const getRowKey = (row: PersonAllocation, index: number) => row.person?.id || `row-${index}`;

  return (
    <Box sx={{ width: '100%' }}>
      <ExpandableDataTable
        columns={columns}
        data={rows}
        renderRow={renderRow}
        getRowKey={getRowKey}
        emptyMessage={t('common:no.data.for.the.chosen.period.and.search.term')}
        maxHeight="35rem"
        stickyHeader
      />
    </Box>
  );
}
